<template>
  <Command @click="trigger">
    <slot
      v-bind="{
        disabled: false,
        icon: 'more_vert',
        label: $t('moreOptions.name'),
        toolTip: $t('moreOptions.iconTooltip'),
      }"
    />
  </Command>
</template>
<script setup lang="ts">
import { OverlayType, useUILayers } from "@/components/UILayers";
import MoreOptions from "@/components/reader/MoreOptions.vue";

import Command from "../command";

const layers = useUILayers();

function trigger() {
  layers.add(MoreOptions, {}, { overlay: OverlayType.Transparent });
}
</script>
